'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    title: {
      type: String,
      default: '我是二级标题'
    },
    titleColor: {
      type: String,
      default: '#fff'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入文本'
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    iscolor: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  },

  watch: {
    value: function value(newVal) {
      this.currentValue = newVal;
    }
  },
  components: {},
  created: function created() {},

  methods: {
    onEnter: function onEnter() {
      this.$emit('on-enter', this.currentValue);
    },
    onClick: function onClick() {
      this.$emit('on-click', this.currentValue);
    }
  }
};